import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'

import BaseButton from 'components/button/base/base_button'
import MainButton from 'components/button/main/main_button'
import SettingsToggle from './SettingsToggle'
import styles from './SettingsPrompt.scss'

const SettingsPrompt = props => (
	<div styleName="SettingsPrompt">
		<div styleName="SettingsPrompt-top">
			<h3 styleName="SettingsPrompt-top-title">{localize('matching_pairs_settings_title')}</h3>
			<SettingsToggle
				title={localize('matching_pairs_settings_random_title')}
				description={localize('matching_pairs_settings_random_prompt')}
				onChage={() => { }}
				checked={0}
			/>
		</div>
		<div styleName="SettingsPrompt-bottom">
			<div styleName="SettingsPrompt-bottom-cancel">
				<BaseButton bgColor="border-blue" fontColor="blue" onClick={props.close}>{localize('matching_pairs_settings_cancel')}</BaseButton>
			</div>
			<div styleName="SettingsPrompt-bottom-delete">
				<MainButton bgColor="blue" fontColor="white" onClick={props.saveSettings}>{localize('matching_pairs_settings_confirm')}</MainButton>
			</div>
		</div>
	</div>
)

SettingsPrompt.propTypes = {
	saveSettings: PropTypes.func.isRequired,
	close: PropTypes.func,
}

SettingsPrompt.defaultProps = {
	saveSettings: () => { },
	close: () => { },
}

export default CSSModules(SettingsPrompt, styles, { allowMultiple: true })
